// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines, removed unused reducers, corrected the response handle
// MODIFIED DATE: 25-09-2025

/* eslint-disable import/no-anonymous-default-export */
import ClosedLoanReportActionTypes from './closed-loan-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// CLOSE LOAN LIST RESPONSE
	getClosedLoanDetailsListResponse: null,
	getClosedLoanDetailsListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************  GET CLOSED LOAN DETAILS LIST START *********************** */
		case ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_SUCCESS:
			return {
				...state,
				getClosedLoanDetailsListResponse: action.payload,
				getClosedLoanDetailsListArr: docodeHexResponse(
					action.payload,
					'GetMemberClosedLoanDetailsKey',
				),
			};

		case ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_FAILURE:
			return { ...state, getClosedLoanDetailsListResponse: action.payload };

		case ClosedLoanReportActionTypes.GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_CHANGED:
			return { ...state, getClosedLoanDetailsListResponse: null };
		/****************  GET CLOSED LOAN DETAILS LIST START *********************** */

		default:
			return state;
	}
};
